import {Component, ElementRef, OnDestroy, OnInit, ViewChild, ViewChildren} from '@angular/core';
import {BaseService} from "../../services/base.service";
import {Subject} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {takeUntil} from "rxjs/operators";
import {SurveyData} from "../../interfaces/survey-data";
import {Spheres} from "../../interfaces/spheres";
import {Areas} from "../../interfaces/areas";
import {Meta, Title} from "@angular/platform-browser";
import {Router} from "@angular/router";
import {NpCities, NpCity} from "../../interfaces/np-city";
import {RequestData} from "../../interfaces/request-data";

// Те саме правило, що user_text_unsafe() на беку (survey/save, #749): лише «<» і «>»
const SURVEY_UNSAFE_TEXT = /[<>]/;
const SURVEY_UNSAFE_TEXT_MESSAGE = 'Не використовуйте символи «<» і «>»';

@Component({
  selector: 'app-survey',
  templateUrl: './survey.component.html',
  styleUrls: ['./survey.component.scss']
})
export class SurveyComponent extends BaseService implements OnDestroy, OnInit {
  @ViewChild('phoneRef') phoneRef;
  @ViewChildren('phoneAdditionRef') phoneAdditionRef;
  @ViewChild('scrollInputRef') scrollInputRef: ElementRef<HTMLInputElement>;

  public isDestroyed: Subject<boolean> = new Subject();
  public fio: string = '';
  public phone: string = '';
  public email : string = '';
  public areaId: number;
  public cityId: string;
  public spheres: Spheres[];
  public address: string = '';
  public isModalShow: boolean = false;
  public isDarkBackground: boolean = false;
  public additionPhones = [];
  public additionalCity = [];
  public additionalSpheres = [];
  public isLabelCheckbox: boolean = false;
  public areas: Areas[];
  public city: string = '';
  public sphereId: number;
  public counterAddress: number = 0;
  public limit: number;
  public timoutSearch;
  public timoutSearchAdditional = [];
  public addressData = [];
  public additionalCityData = [];
  public wrongFio: boolean = false;
  public errorMessageFio: string = '';
  public wrongPhone: boolean = false;
  public errorMessagePhone: string = '';
  public wrongCity: boolean = false;
  public errorMessageCity: string = '';
  public wrongSphere: boolean = false;
  public errorMessageSphere: string = '';
  public wrongAddress: boolean = false;
  public errorMessageAddress: string = '';
  public isValidSurveyForm: boolean = false;

  constructor(
    private http: HttpClient,
    private titleService: Title,
    private meta: Meta,
    private router: Router,
  ) {
    super();

    const title = 'Маслоточка | Анкетування';
    this.titleService.setTitle(title);
    this.meta.addTag({name: 'title', content: title});
    this.meta.addTag({name: 'og:title', content: title});
    this.meta.addTag({name: 'twitter:title', content: title});
    this.meta.addTag({name: 'DC.title', content: title});
  }

  ngOnInit() {
    this.http.get(this.apiRoot + 'survey/data')
      .pipe(takeUntil(this.isDestroyed))
      .subscribe((data: SurveyData) => {
        if (data.data.surveyed == 2) {
          setTimeout(() => {
            this.router.navigate(['account']);
          }, 500);
        }

        this.address = data.data.address;
        this.areaId = data.data.area_id;
        this.areas = Object.values(data.data.areas);
        this.city = data.data.city;
        this.email = data.data.email;
        this.fio = data.data.fio;
        this.phone = data.data.phone;
        this.spheres = data.data.sphere;
        this.sphereId = data.data.sphere_id;
        this.cityId = data.data.city_id;
      })
  }

  scrollToInvalidForm() {
    if (this.wrongFio || this.wrongPhone || this.wrongCity || this.wrongAddress) {
      this.scrollInputRef.nativeElement.scrollIntoView();
    }
  }

  validationFio() {
    if (!/^[A-Za-zА-Яа-яІЇіїЄєҐґ.,\-+='’ʼ‘"“”«»„\d:() ]{3,60}$/.test(this.fio)) {
      this.wrongFio = true;
      this.isValidSurveyForm = true;
      this.errorMessageFio = 'Введіть своє ім\'я та прізвище';
    } else {
      this.wrongFio = false;
    }
  }

  validationPhone() {
    const phone = this.phoneRef.nativeElement.value.replace(/\+38/g, '').replace(/\D/g, '');

    if (!/^\d{10}$/.test(phone)) {
      this.wrongPhone = true;
      this.isValidSurveyForm = true;
      this.errorMessagePhone = 'Введіть номер мобільного телефону';
    } else {
      this.wrongPhone = false;
    }
  }

  validationAdditionalPhone() {
    for (let i in this.additionPhones) {
      let validPhone = this.additionPhones[i];
      const phoneAdd = this.phoneAdditionRef.get(i).nativeElement.value.replace(/\+38/g, '').replace(/\D/g, '');

      if (!/^\d{10}$/.test(phoneAdd)) {
        this.isValidSurveyForm = true;
        validPhone.error = true;
        validPhone.errorMessage = 'Введіть додатковий номер мобільного телефону';
      } else {
        validPhone.error = false;
        validPhone.errorMessage = '';
      }
    }
  }

  addPhone() {
    this.additionPhones.push({
      name: '',
      error: false,
      errorMessage: ''
    });
  }

  addArea() {
    this.counterAddress += 1;

    this.additionalCity.push({
      city: '',
      city_id: '',
      area_id: '',
      error: false,
      errorMessage: ''
    });
  }

  validationCity() {
    if (!this.areaId || !this.cityId || !this.city) {
      this.wrongCity = true;
      this.isValidSurveyForm = true;
      this.errorMessageCity = 'Виберіть місто зі списку';
    } else {
      this.wrongCity = false;
    }
  }

  searchCity() {
    clearTimeout(this.timoutSearch);

    // Текст міста змінено вручну - старий city_id/area_id НП більше не відповідає назві,
    // скидаємо і вимагаємо вибір зі списку (getCity)
    this.cityId = '';
    this.areaId = null;

    if (!this.city || this.city.length < 3) {
      this.addressData = [];
      this.validationCity();
      return;
    }

    this.timoutSearch = setTimeout(() => {
      this.getNpCities(this.city)
        .pipe(takeUntil(this.isDestroyed))
        .subscribe((data: NpCities) => {
          this.addressData = data && Array.isArray(data.data) ? data.data : [];
          this.validationCity();
        })
    }, 500);
  }

  getCity(i) {
    const city: NpCity = this.addressData[i];

    this.city = city.description;
    this.cityId = city.ref;
    this.areaId = city.area_id;
    this.addressData = [];
    this.wrongCity = false;
  }

  validationAdditionalCity() {
    for (let validCity of this.additionalCity) {
      if (validCity.city === '') {
        this.isValidSurveyForm = true;
        validCity.error = true;
        validCity.errorMessage = 'Виберіть додаткове місто';
      } else if (!validCity.city_id || !validCity.area_id) {
        this.isValidSurveyForm = true;
        validCity.error = true;
        validCity.errorMessage = 'Виберіть місто зі списку';
      } else {
        validCity.error = false;
        validCity.errorMessage = '';
      }
    }
  }

  searchAdditionalCity(index) {
    if (this.timoutSearchAdditional.hasOwnProperty(index)) {
      clearTimeout(this.timoutSearchAdditional[index]);
    }

    // Як і для основного міста: ручна правка тексту скидає вибраний раніше city_id/area_id
    this.additionalCity[index].city_id = '';
    this.additionalCity[index].area_id = '';

    if (!this.additionalCity[index].city || this.additionalCity[index].city.length < 3) {
      this.additionalCityData[index] = [];
      this.validationAdditionalCity();
      return;
    }

    this.timoutSearchAdditional[index] = setTimeout(() => {
      this.getNpCities(this.additionalCity[index].city)
        .pipe(takeUntil(this.isDestroyed))
        .subscribe((data: NpCities) => {
          this.additionalCityData[index] = data && Array.isArray(data.data) ? data.data : [];

          this.validationAdditionalCity();
        })
    }, 500);
  }

  validationAddress() {
    if (this.address === '') {
      this.wrongAddress = true;
      this.isValidSurveyForm = true;
      this.errorMessageAddress = 'Введіть свій адрес';
    } else if (SURVEY_UNSAFE_TEXT.test(this.address)) {
      this.wrongAddress = true;
      this.isValidSurveyForm = true;
      this.errorMessageAddress = SURVEY_UNSAFE_TEXT_MESSAGE;
    } else {
      this.wrongAddress = false;
    }
  }

  getAdditionalCity(index, addIndex) {
    const city: NpCity = this.additionalCityData[addIndex][index];

    this.additionalCity[addIndex].city = city.description;
    this.additionalCity[addIndex].city_id = city.ref;
    this.additionalCity[addIndex].area_id = city.area_id;
    this.additionalCityData[addIndex] = [];
    this.additionalCity[addIndex].error = false;
    this.additionalCity[addIndex].errorMessage = '';
  }

  validationAdditionalSphere() {
    for (let validSphere of this.additionalSpheres) {
      // Раніше порівнювались сфера з адресою: блок з адресою, але без сфери, проходив
      // і бек зберігав порожню сферу в additional_spheres
      if (!validSphere.name) {
        this.isValidSurveyForm = true;
        validSphere.errorSphere = true;
        validSphere.errorMessageSphere = 'Виберіть сферу діяльності';
      } else {
        validSphere.errorSphere = false;
        validSphere.errorMessageSphere = '';
      }

      // Додаткову адресу бек відхиляє з «<»/«>» (#749, 'wrong additional address')
      if (SURVEY_UNSAFE_TEXT.test(validSphere.address || '')) {
        this.isValidSurveyForm = true;
        validSphere.error = true;
        validSphere.errorMessage = SURVEY_UNSAFE_TEXT_MESSAGE;
      } else {
        validSphere.error = false;
        validSphere.errorMessage = '';
      }
    }
  }

  addSphere() {
    this.additionalSpheres.push({
      name: '',
      address: '',
      error: false,
      errorSphere: false,
      errorMessage: '',
      errorMessageSphere: ''
    });
  }

  passConditions() {
    this.isLabelCheckbox = !this.isLabelCheckbox;
  }

  openModal() {
    this.isModalShow = true;
    this.isDarkBackground = true;
  }

  closeModal() {
    this.isModalShow = false;
    this.isDarkBackground = false
  }

  closePhone(i) {
    this.additionPhones.splice(i, 1);
  }

  closeAddress(i) {
    this.counterAddress -= 1;
    this.additionalCity.splice(i, 1);
  }

  closeAddressSpheres(i) {
    this.additionalSpheres.splice(i, 1);
  }

  buttonSaveSurvey() {
    this.isValidSurveyForm = false;

    this.validationFio();

    this.validationPhone();

    this.validationAdditionalPhone();

    this.validationCity();

    this.validationAdditionalCity();

    this.validationAddress();

    this.validationAdditionalSphere();

    if (!this.isValidSurveyForm) {
      this.http.post(this.apiRoot + 'survey/save', {
        fio: this.fio,
        phone: '+' + this.phoneRef.nativeElement.value.replace(/\D/g, ''),
        phones: this.additionPhones.map((el, i) => '+' + this.phoneAdditionRef.get(i).nativeElement.value.replace(/\D/g, '')),
        city_id: this.cityId,
        area_id: this.areaId,
        city: this.city,
        additionalCity: this.additionalCity,
        sphere_id: this.sphereId,
        address: this.address,
        additionalSpheres: this.additionalSpheres,
      })
        .pipe(takeUntil(this.isDestroyed))
        .subscribe((data: RequestData) => {
          if (data.error === 'empty fio') {
            this.wrongFio = true;
            this.errorMessageFio = 'Введіть своє ім\'я та прізвище';
          }

          if (data.error === 'wrong phone') {
            this.wrongPhone = true;
            this.errorMessagePhone = 'Введіть номер мобільного телефону'
          }

          if (data.error === 'empty area_id' || data.error === 'empty city_id' || data.error === 'empty city') {
            this.wrongCity = true;
            this.errorMessageCity = 'Виберіть Ваше місто';
            this.city = '';
          }

          if (data.error === 'empty sphere_id') {
            this.wrongSphere = true;
            this.errorMessageSphere = 'Виберіть сферу діяльності';
          }

          if (data.error === 'empty address') {
            this.wrongAddress = true;
            this.errorMessageAddress = 'Введіть свій адрес'
          }

          // Коди #749 (бек відхиляє «<»/«>»): без них анкета мовчки не зберігалась,
          // а без анкети кабінет не відкривається
          if (data.error === 'wrong fio') {
            this.wrongFio = true;
            this.errorMessageFio = SURVEY_UNSAFE_TEXT_MESSAGE;
          }

          if (data.error === 'wrong address') {
            this.wrongAddress = true;
            this.errorMessageAddress = SURVEY_UNSAFE_TEXT_MESSAGE;
          }

          if (data.error === 'wrong additional address') {
            for (const addSphere of this.additionalSpheres) {
              if (SURVEY_UNSAFE_TEXT.test(addSphere.address || '')) {
                addSphere.error = true;
                addSphere.errorMessage = SURVEY_UNSAFE_TEXT_MESSAGE;
              }
            }
          }

          if (data.data === 'success') {
            this.router.navigate(['account']);
          }
        })
    } else {
      this.scrollToInvalidForm();
    }
  }

  getNpCities(search: string) {
    return this.http.post(this.apiRoot + 'geo/search_cities', {
      search: search,
    })
  }

  ngOnDestroy() {
    this.isDestroyed.next(true);
    this.isDestroyed.complete();
  }
}
